import React from 'react';
import { PARTNERS_HOW_IT_WORKS_ID } from '../constants';
import PartnersCtaButton from '../components/PartnersCtaButton';
import PartnersSectionHeading from '../components/PartnersSectionHeading';
import { usePartnersStrings } from '../usePartnersStrings';

const PartnersHowItWorks: React.FC = () => {
  const s = usePartnersStrings();

  return (
    <section id={PARTNERS_HOW_IT_WORKS_ID} className="container-chisme scroll-mt-24 py-10 lg:py-16">
      <PartnersSectionHeading
        title={
          <>
            <span className="block">{s.howItWorks.titleLine1}</span>
            <span className="block italic text-chisme-primary">{s.howItWorks.titleLine2}</span>
          </>
        }
        subtitle={s.howItWorks.subtitle}
      />

      <ol className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
        {s.howItWorks.steps.map((step, index) => (
          <li
            key={step.title}
            className="flex h-full flex-col rounded-[24px] border border-[rgba(74,33,71,0.1)] bg-white p-6"
          >
            <span className="font-instrument text-4xl italic text-chisme-primary/30">
              {String(index + 1).padStart(2, '0')}
            </span>
            <h3 className="mt-4 font-instrument text-2xl italic tracking-[-0.01em] text-[#2a0f2a]">
              {step.title}
            </h3>
            <p className="mt-2 flex-1 font-jakarta text-[14.5px] leading-relaxed text-[#5a3158]">
              {step.description}
            </p>
          </li>
        ))}
      </ol>

      <div className="mt-10 text-center">
        <PartnersCtaButton>{s.cta.registerBusiness}</PartnersCtaButton>
      </div>
    </section>
  );
};

export default PartnersHowItWorks;
